/**
 * Child Support Amounts for 2025
 * 
 * Data exported from [calc].child_support_amount table
 * tax_year_lookup_id: 5 (2025 = 5 + 2020)
 */

import { ChildSupportLevel } from '../../../types';

export const childSupportLevelsIA2025: ChildSupportLevel[] = [
  {
    combinedAdjustedNetIncomeMinimum: 0,
    combinedAdjustedNetIncomeMaximum: 100.99,
    amounts: [50, 75, 100, 100, 100],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 101,
    combinedAdjustedNetIncomeMaximum: 200.99,
    amounts: [56, 82, 107, 109, 110],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 201,
    combinedAdjustedNetIncomeMaximum: 300.99,
    amounts: [61, 90, 115, 118, 121],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 301,
    combinedAdjustedNetIncomeMaximum: 400.99,
    amounts: [67, 97, 122, 127, 131],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 401,
    combinedAdjustedNetIncomeMaximum: 500.99,
    amounts: [72, 105, 129, 136, 142],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 501,
    combinedAdjustedNetIncomeMaximum: 600.99,
    amounts: [78, 112, 137, 145, 152],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 601,
    combinedAdjustedNetIncomeMaximum: 700.99,
    amounts: [84, 120, 144, 154, 163],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 701,
    combinedAdjustedNetIncomeMaximum: 800.99,
    amounts: [89, 127, 152, 163, 173],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 801,
    combinedAdjustedNetIncomeMaximum: 850.99,
    amounts: [95, 134, 159, 172, 184],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 851,
    combinedAdjustedNetIncomeMaximum: 900.99,
    amounts: [100, 142, 166, 181, 194],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 901,
    combinedAdjustedNetIncomeMaximum: 950.99,
    amounts: [106, 149, 174, 190, 205],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 951,
    combinedAdjustedNetIncomeMaximum: 1000.99,
    amounts: [111, 157, 181, 199, 215],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1001,
    combinedAdjustedNetIncomeMaximum: 1050.99,
    amounts: [117, 164, 188, 208, 226],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1051,
    combinedAdjustedNetIncomeMaximum: 1100.99,
    amounts: [123, 171, 196, 217, 236],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'a' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1101,
    combinedAdjustedNetIncomeMaximum: 1150.99,
    amounts: [128, 179, 203, 226, 247],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1151,
    combinedAdjustedNetIncomeMaximum: 1200.99,
    amounts: [153, 209, 235, 258, 284],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1201,
    combinedAdjustedNetIncomeMaximum: 1250.99,
    amounts: [178, 239, 268, 290, 321],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1251,
    combinedAdjustedNetIncomeMaximum: 1300.99,
    amounts: [203, 269, 300, 323, 359],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1301,
    combinedAdjustedNetIncomeMaximum: 1350.99,
    amounts: [228, 299, 333, 355, 396],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1351,
    combinedAdjustedNetIncomeMaximum: 1400.99,
    amounts: [253, 329, 365, 388, 434],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1401,
    combinedAdjustedNetIncomeMaximum: 1450.99,
    amounts: [278, 359, 398, 420, 471],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1451,
    combinedAdjustedNetIncomeMaximum: 1500.99,
    amounts: [303, 389, 430, 453, 509],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1501,
    combinedAdjustedNetIncomeMaximum: 1550.99,
    amounts: [328, 419, 463, 485, 546],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1551,
    combinedAdjustedNetIncomeMaximum: 1600.99,
    amounts: [353, 449, 495, 518, 584],
    lowIncomes: [true, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1601,
    combinedAdjustedNetIncomeMaximum: 1650.99,
    amounts: [375, 479, 528, 550, 621],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1651,
    combinedAdjustedNetIncomeMaximum: 1700.99,
    amounts: [386, 509, 560, 583, 659],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1701,
    combinedAdjustedNetIncomeMaximum: 1750.99,
    amounts: [398, 539, 593, 615, 696],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1751,
    combinedAdjustedNetIncomeMaximum: 1800.99,
    amounts: [409, 569, 625, 648, 734],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1801,
    combinedAdjustedNetIncomeMaximum: 1850.99,
    amounts: [421, 599, 658, 680, 771],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1851,
    combinedAdjustedNetIncomeMaximum: 1900.99,
    amounts: [432, 629, 690, 713, 809],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1901,
    combinedAdjustedNetIncomeMaximum: 1950.99,
    amounts: [444, 659, 723, 745, 846],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 1951,
    combinedAdjustedNetIncomeMaximum: 2000.99,
    amounts: [455, 689, 755, 778, 869],
    lowIncomes: [false, true, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2001,
    combinedAdjustedNetIncomeMaximum: 2050.99,
    amounts: [467, 711, 788, 810, 891],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2051,
    combinedAdjustedNetIncomeMaximum: 2100.99,
    amounts: [478, 728, 820, 843, 913],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2101,
    combinedAdjustedNetIncomeMaximum: 2150.99,
    amounts: [490, 746, 853, 875, 935],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2151,
    combinedAdjustedNetIncomeMaximum: 2200.99,
    amounts: [501, 763, 885, 908, 957],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2201,
    combinedAdjustedNetIncomeMaximum: 2250.99,
    amounts: [513, 781, 918, 940, 979],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2251,
    combinedAdjustedNetIncomeMaximum: 2300.99,
    amounts: [524, 798, 950, 973, 1001],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2301,
    combinedAdjustedNetIncomeMaximum: 2350.99,
    amounts: [536, 816, 983, 1000, 1023],
    lowIncomes: [false, false, true, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2351,
    combinedAdjustedNetIncomeMaximum: 2400.99,
    amounts: [547, 833, 1008, 1021, 1045],
    lowIncomes: [false, false, false, true, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2401,
    combinedAdjustedNetIncomeMaximum: 2450.99,
    amounts: [559, 851, 1029, 1043, 1067],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2451,
    combinedAdjustedNetIncomeMaximum: 2500.99,
    amounts: [570, 869, 1050, 1064, 1089],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2501,
    combinedAdjustedNetIncomeMaximum: 2550.99,
    amounts: [582, 886, 1071, 1086, 1111],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2551,
    combinedAdjustedNetIncomeMaximum: 2600.99,
    amounts: [593, 904, 1092, 1107, 1133],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2601,
    combinedAdjustedNetIncomeMaximum: 2650.99,
    amounts: [605, 921, 1114, 1129, 1155],
    lowIncomes: [false, false, false, false, true],
    incomeArea: 'b' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2651,
    combinedAdjustedNetIncomeMaximum: 2700.99,
    amounts: [616, 939, 1135, 1150, 1177],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2701,
    combinedAdjustedNetIncomeMaximum: 2750.99,
    amounts: [628, 956, 1156, 1172, 1199],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2751,
    combinedAdjustedNetIncomeMaximum: 2800.99,
    amounts: [640, 973, 1175, 1193, 1221],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2801,
    combinedAdjustedNetIncomeMaximum: 2850.99,
    amounts: [651, 988, 1193, 1215, 1243],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2851,
    combinedAdjustedNetIncomeMaximum: 2900.99,
    amounts: [663, 1003, 1210, 1236, 1265],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2901,
    combinedAdjustedNetIncomeMaximum: 2950.99,
    amounts: [674, 1018, 1227, 1258, 1287],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 2951,
    combinedAdjustedNetIncomeMaximum: 3000.99,
    amounts: [686, 1033, 1245, 1279, 1309],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3001,
    combinedAdjustedNetIncomeMaximum: 3050.99,
    amounts: [697, 1049, 1262, 1301, 1331],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3051,
    combinedAdjustedNetIncomeMaximum: 3100.99,
    amounts: [709, 1064, 1280, 1322, 1353],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3101,
    combinedAdjustedNetIncomeMaximum: 3150.99,
    amounts: [720, 1079, 1297, 1344, 1375],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3151,
    combinedAdjustedNetIncomeMaximum: 3200.99,
    amounts: [732, 1094, 1315, 1365, 1397],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3201,
    combinedAdjustedNetIncomeMaximum: 3250.99,
    amounts: [742, 1111, 1335, 1387, 1419],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3251,
    combinedAdjustedNetIncomeMaximum: 3300.99,
    amounts: [752, 1128, 1355, 1408, 1441],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3301,
    combinedAdjustedNetIncomeMaximum: 3350.99,
    amounts: [763, 1145, 1375, 1430, 1463],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3351,
    combinedAdjustedNetIncomeMaximum: 3400.99,
    amounts: [773, 1162, 1395, 1451, 1485],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3401,
    combinedAdjustedNetIncomeMaximum: 3450.99,
    amounts: [784, 1179, 1415, 1473, 1507],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3451,
    combinedAdjustedNetIncomeMaximum: 3500.99,
    amounts: [794, 1196, 1435, 1494, 1529],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3501,
    combinedAdjustedNetIncomeMaximum: 3550.99,
    amounts: [805, 1213, 1455, 1516, 1551],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3551,
    combinedAdjustedNetIncomeMaximum: 3600.99,
    amounts: [815, 1230, 1475, 1537, 1573],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3601,
    combinedAdjustedNetIncomeMaximum: 3650.99,
    amounts: [824, 1245, 1493, 1559, 1595],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3651,
    combinedAdjustedNetIncomeMaximum: 3700.99,
    amounts: [833, 1257, 1508, 1580, 1617],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3701,
    combinedAdjustedNetIncomeMaximum: 3750.99,
    amounts: [841, 1270, 1523, 1602, 1639],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3751,
    combinedAdjustedNetIncomeMaximum: 3800.99,
    amounts: [850, 1283, 1538, 1623, 1661],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3801,
    combinedAdjustedNetIncomeMaximum: 3850.99,
    amounts: [858, 1295, 1553, 1645, 1683],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3851,
    combinedAdjustedNetIncomeMaximum: 3900.99,
    amounts: [867, 1308, 1568, 1666, 1705],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3901,
    combinedAdjustedNetIncomeMaximum: 3950.99,
    amounts: [875, 1321, 1583, 1688, 1727],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 3951,
    combinedAdjustedNetIncomeMaximum: 4000.99,
    amounts: [884, 1333, 1598, 1709, 1749],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4001,
    combinedAdjustedNetIncomeMaximum: 4050.99,
    amounts: [892, 1345, 1612, 1730, 1771],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4051,
    combinedAdjustedNetIncomeMaximum: 4100.99,
    amounts: [897, 1353, 1620, 1748, 1793],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4101,
    combinedAdjustedNetIncomeMaximum: 4150.99,
    amounts: [902, 1360, 1629, 1766, 1815],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4151,
    combinedAdjustedNetIncomeMaximum: 4200.99,
    amounts: [907, 1368, 1637, 1784, 1837],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4201,
    combinedAdjustedNetIncomeMaximum: 4250.99,
    amounts: [912, 1375, 1646, 1802, 1859],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4251,
    combinedAdjustedNetIncomeMaximum: 4300.99,
    amounts: [918, 1383, 1654, 1820, 1881],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4301,
    combinedAdjustedNetIncomeMaximum: 4350.99,
    amounts: [923, 1390, 1663, 1838, 1903],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4351,
    combinedAdjustedNetIncomeMaximum: 4400.99,
    amounts: [928, 1398, 1671, 1856, 1925],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4401,
    combinedAdjustedNetIncomeMaximum: 4450.99,
    amounts: [933, 1405, 1680, 1873, 1947],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4451,
    combinedAdjustedNetIncomeMaximum: 4500.99,
    amounts: [938, 1411, 1685, 1882, 1967],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4501,
    combinedAdjustedNetIncomeMaximum: 4550.99,
    amounts: [943, 1417, 1690, 1887, 1986],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4551,
    combinedAdjustedNetIncomeMaximum: 4600.99,
    amounts: [948, 1422, 1694, 1892, 2005],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4601,
    combinedAdjustedNetIncomeMaximum: 4650.99,
    amounts: [952, 1428, 1699, 1897, 2023],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4651,
    combinedAdjustedNetIncomeMaximum: 4700.99,
    amounts: [957, 1433, 1703, 1902, 2042],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4701,
    combinedAdjustedNetIncomeMaximum: 4750.99,
    amounts: [962, 1438, 1707, 1907, 2061],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4751,
    combinedAdjustedNetIncomeMaximum: 4800.99,
    amounts: [966, 1444, 1712, 1912, 2080],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4801,
    combinedAdjustedNetIncomeMaximum: 4850.99,
    amounts: [971, 1449, 1716, 1917, 2098],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4851,
    combinedAdjustedNetIncomeMaximum: 4900.99,
    amounts: [976, 1456, 1723, 1924, 2117],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4901,
    combinedAdjustedNetIncomeMaximum: 4950.99,
    amounts: [983, 1467, 1738, 1941, 2135],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 4951,
    combinedAdjustedNetIncomeMaximum: 5000.99,
    amounts: [989, 1478, 1752, 1957, 2153],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5001,
    combinedAdjustedNetIncomeMaximum: 5050.99,
    amounts: [996, 1489, 1767, 1974, 2171],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5051,
    combinedAdjustedNetIncomeMaximum: 5100.99,
    amounts: [1003, 1500, 1781, 1990, 2189],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5101,
    combinedAdjustedNetIncomeMaximum: 5150.99,
    amounts: [1009, 1511, 1796, 2006, 2207],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5151,
    combinedAdjustedNetIncomeMaximum: 5200.99,
    amounts: [1016, 1522, 1811, 2023, 2225],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5201,
    combinedAdjustedNetIncomeMaximum: 5250.99,
    amounts: [1022, 1533, 1825, 2039, 2243],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5251,
    combinedAdjustedNetIncomeMaximum: 5300.99,
    amounts: [1029, 1544, 1840, 2055, 2261],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5301,
    combinedAdjustedNetIncomeMaximum: 5350.99,
    amounts: [1033, 1550, 1846, 2062, 2269],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5351,
    combinedAdjustedNetIncomeMaximum: 5400.99,
    amounts: [1037, 1555, 1850, 2067, 2273],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5401,
    combinedAdjustedNetIncomeMaximum: 5450.99,
    amounts: [1041, 1560, 1854, 2071, 2278],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5451,
    combinedAdjustedNetIncomeMaximum: 5500.99,
    amounts: [1045, 1564, 1858, 2075, 2282],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5501,
    combinedAdjustedNetIncomeMaximum: 5550.99,
    amounts: [1049, 1569, 1861, 2079, 2287],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5551,
    combinedAdjustedNetIncomeMaximum: 5600.99,
    amounts: [1053, 1573, 1865, 2083, 2291],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5601,
    combinedAdjustedNetIncomeMaximum: 5650.99,
    amounts: [1057, 1578, 1869, 2087, 2296],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5651,
    combinedAdjustedNetIncomeMaximum: 5700.99,
    amounts: [1061, 1583, 1872, 2091, 2301],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5701,
    combinedAdjustedNetIncomeMaximum: 5750.99,
    amounts: [1066, 1588, 1877, 2097, 2307],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5751,
    combinedAdjustedNetIncomeMaximum: 5800.99,
    amounts: [1071, 1595, 1885, 2105, 2316],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5801,
    combinedAdjustedNetIncomeMaximum: 5850.99,
    amounts: [1077, 1603, 1892, 2113, 2325],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5851,
    combinedAdjustedNetIncomeMaximum: 5900.99,
    amounts: [1083, 1610, 1899, 2122, 2334],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5901,
    combinedAdjustedNetIncomeMaximum: 5950.99,
    amounts: [1088, 1617, 1907, 2130, 2343],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 5951,
    combinedAdjustedNetIncomeMaximum: 6000.99,
    amounts: [1094, 1624, 1914, 2138, 2352],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6001,
    combinedAdjustedNetIncomeMaximum: 6050.99,
    amounts: [1099, 1632, 1922, 2146, 2361],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6051,
    combinedAdjustedNetIncomeMaximum: 6100.99,
    amounts: [1105, 1639, 1929, 2155, 2370],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6101,
    combinedAdjustedNetIncomeMaximum: 6150.99,
    amounts: [1110, 1646, 1936, 2163, 2379],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6151,
    combinedAdjustedNetIncomeMaximum: 6200.99,
    amounts: [1118, 1657, 1948, 2176, 2394],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6201,
    combinedAdjustedNetIncomeMaximum: 6250.99,
    amounts: [1126, 1669, 1961, 2191, 2410],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6251,
    combinedAdjustedNetIncomeMaximum: 6300.99,
    amounts: [1135, 1680, 1974, 2205, 2426],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6301,
    combinedAdjustedNetIncomeMaximum: 6350.99,
    amounts: [1143, 1692, 1987, 2219, 2441],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6351,
    combinedAdjustedNetIncomeMaximum: 6400.99,
    amounts: [1151, 1704, 2000, 2234, 2457],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6401,
    combinedAdjustedNetIncomeMaximum: 6450.99,
    amounts: [1160, 1715, 2013, 2248, 2473],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6451,
    combinedAdjustedNetIncomeMaximum: 6500.99,
    amounts: [1168, 1727, 2026, 2262, 2489],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6501,
    combinedAdjustedNetIncomeMaximum: 6550.99,
    amounts: [1176, 1738, 2038, 2277, 2505],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6551,
    combinedAdjustedNetIncomeMaximum: 6600.99,
    amounts: [1184, 1750, 2051, 2291, 2520],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6601,
    combinedAdjustedNetIncomeMaximum: 6650.99,
    amounts: [1193, 1762, 2064, 2306, 2536],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6651,
    combinedAdjustedNetIncomeMaximum: 6700.99,
    amounts: [1201, 1773, 2077, 2320, 2552],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6701,
    combinedAdjustedNetIncomeMaximum: 6750.99,
    amounts: [1209, 1785, 2090, 2334, 2568],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6751,
    combinedAdjustedNetIncomeMaximum: 6800.99,
    amounts: [1217, 1796, 2103, 2349, 2583],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6801,
    combinedAdjustedNetIncomeMaximum: 6850.99,
    amounts: [1223, 1806, 2116, 2363, 2599],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6851,
    combinedAdjustedNetIncomeMaximum: 6900.99,
    amounts: [1229, 1816, 2128, 2378, 2615],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6901,
    combinedAdjustedNetIncomeMaximum: 6950.99,
    amounts: [1235, 1826, 2141, 2392, 2631],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 6951,
    combinedAdjustedNetIncomeMaximum: 7000.99,
    amounts: [1241, 1836, 2154, 2406, 2647],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7001,
    combinedAdjustedNetIncomeMaximum: 7050.99,
    amounts: [1247, 1846, 2167, 2421, 2663],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7051,
    combinedAdjustedNetIncomeMaximum: 7100.99,
    amounts: [1253, 1856, 2180, 2435, 2679],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7101,
    combinedAdjustedNetIncomeMaximum: 7150.99,
    amounts: [1259, 1866, 2193, 2450, 2695],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7151,
    combinedAdjustedNetIncomeMaximum: 7200.99,
    amounts: [1265, 1876, 2206, 2464, 2711],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7201,
    combinedAdjustedNetIncomeMaximum: 7250.99,
    amounts: [1271, 1886, 2219, 2479, 2727],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7251,
    combinedAdjustedNetIncomeMaximum: 7300.99,
    amounts: [1277, 1896, 2232, 2493, 2742],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7301,
    combinedAdjustedNetIncomeMaximum: 7350.99,
    amounts: [1283, 1906, 2245, 2508, 2758],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7351,
    combinedAdjustedNetIncomeMaximum: 7400.99,
    amounts: [1289, 1916, 2258, 2522, 2774],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7401,
    combinedAdjustedNetIncomeMaximum: 7450.99,
    amounts: [1295, 1924, 2268, 2534, 2787],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7451,
    combinedAdjustedNetIncomeMaximum: 7500.99,
    amounts: [1300, 1930, 2275, 2542, 2796],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7501,
    combinedAdjustedNetIncomeMaximum: 7550.99,
    amounts: [1304, 1937, 2283, 2550, 2805],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7551,
    combinedAdjustedNetIncomeMaximum: 7600.99,
    amounts: [1309, 1944, 2290, 2558, 2813],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7601,
    combinedAdjustedNetIncomeMaximum: 7650.99,
    amounts: [1314, 1950, 2297, 2566, 2822],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7651,
    combinedAdjustedNetIncomeMaximum: 7700.99,
    amounts: [1318, 1957, 2304, 2574, 2831],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7701,
    combinedAdjustedNetIncomeMaximum: 7750.99,
    amounts: [1323, 1963, 2311, 2582, 2840],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7751,
    combinedAdjustedNetIncomeMaximum: 7800.99,
    amounts: [1328, 1970, 2318, 2590, 2849],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7801,
    combinedAdjustedNetIncomeMaximum: 7850.99,
    amounts: [1333, 1976, 2326, 2598, 2858],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7851,
    combinedAdjustedNetIncomeMaximum: 7900.99,
    amounts: [1337, 1983, 2333, 2606, 2866],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7901,
    combinedAdjustedNetIncomeMaximum: 7950.99,
    amounts: [1342, 1989, 2340, 2614, 2875],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 7951,
    combinedAdjustedNetIncomeMaximum: 8000.99,
    amounts: [1347, 1996, 2347, 2622, 2884],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8001,
    combinedAdjustedNetIncomeMaximum: 8050.99,
    amounts: [1351, 2003, 2354, 2630, 2893],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8051,
    combinedAdjustedNetIncomeMaximum: 8100.99,
    amounts: [1357, 2010, 2362, 2639, 2903],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8101,
    combinedAdjustedNetIncomeMaximum: 8150.99,
    amounts: [1363, 2018, 2371, 2648, 2913],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8151,
    combinedAdjustedNetIncomeMaximum: 8200.99,
    amounts: [1369, 2026, 2379, 2657, 2923],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8201,
    combinedAdjustedNetIncomeMaximum: 8250.99,
    amounts: [1375, 2034, 2387, 2667, 2933],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8251,
    combinedAdjustedNetIncomeMaximum: 8300.99,
    amounts: [1381, 2043, 2396, 2676, 2943],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8301,
    combinedAdjustedNetIncomeMaximum: 8350.99,
    amounts: [1388, 2051, 2404, 2685, 2954],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8351,
    combinedAdjustedNetIncomeMaximum: 8400.99,
    amounts: [1394, 2059, 2412, 2694, 2964],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8401,
    combinedAdjustedNetIncomeMaximum: 8450.99,
    amounts: [1400, 2067, 2421, 2704, 2974],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8451,
    combinedAdjustedNetIncomeMaximum: 8500.99,
    amounts: [1406, 2075, 2429, 2713, 2984],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8501,
    combinedAdjustedNetIncomeMaximum: 8550.99,
    amounts: [1412, 2083, 2437, 2722, 2994],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8551,
    combinedAdjustedNetIncomeMaximum: 8600.99,
    amounts: [1418, 2091, 2445, 2732, 3005],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8601,
    combinedAdjustedNetIncomeMaximum: 8650.99,
    amounts: [1424, 2099, 2454, 2741, 3015],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8651,
    combinedAdjustedNetIncomeMaximum: 8700.99,
    amounts: [1430, 2107, 2462, 2750, 3025],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8701,
    combinedAdjustedNetIncomeMaximum: 8750.99,
    amounts: [1436, 2115, 2470, 2759, 3035],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8751,
    combinedAdjustedNetIncomeMaximum: 8800.99,
    amounts: [1442, 2123, 2479, 2769, 3045],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8801,
    combinedAdjustedNetIncomeMaximum: 8850.99,
    amounts: [1448, 2131, 2487, 2778, 3056],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8851,
    combinedAdjustedNetIncomeMaximum: 8900.99,
    amounts: [1454, 2139, 2495, 2787, 3066],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8901,
    combinedAdjustedNetIncomeMaximum: 8950.99,
    amounts: [1458, 2144, 2500, 2793, 3072],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 8951,
    combinedAdjustedNetIncomeMaximum: 9000.99,
    amounts: [1462, 2149, 2505, 2798, 3078],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9001,
    combinedAdjustedNetIncomeMaximum: 9050.99,
    amounts: [1466, 2154, 2510, 2803, 3084],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9051,
    combinedAdjustedNetIncomeMaximum: 9100.99,
    amounts: [1470, 2159, 2514, 2808, 3089],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9101,
    combinedAdjustedNetIncomeMaximum: 9150.99,
    amounts: [1474, 2164, 2519, 2814, 3095],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9151,
    combinedAdjustedNetIncomeMaximum: 9200.99,
    amounts: [1478, 2169, 2524, 2819, 3101],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9201,
    combinedAdjustedNetIncomeMaximum: 9250.99,
    amounts: [1482, 2174, 2528, 2824, 3106],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9251,
    combinedAdjustedNetIncomeMaximum: 9300.99,
    amounts: [1485, 2178, 2533, 2829, 3112],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9301,
    combinedAdjustedNetIncomeMaximum: 9350.99,
    amounts: [1489, 2183, 2537, 2834, 3118],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9351,
    combinedAdjustedNetIncomeMaximum: 9400.99,
    amounts: [1493, 2188, 2542, 2839, 3123],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9401,
    combinedAdjustedNetIncomeMaximum: 9450.99,
    amounts: [1497, 2193, 2547, 2845, 3129],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9451,
    combinedAdjustedNetIncomeMaximum: 9500.99,
    amounts: [1501, 2198, 2551, 2850, 3135],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9501,
    combinedAdjustedNetIncomeMaximum: 9550.99,
    amounts: [1505, 2203, 2556, 2855, 3141],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9551,
    combinedAdjustedNetIncomeMaximum: 9600.99,
    amounts: [1509, 2208, 2561, 2860, 3146],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9601,
    combinedAdjustedNetIncomeMaximum: 9650.99,
    amounts: [1512, 2212, 2565, 2865, 3152],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9651,
    combinedAdjustedNetIncomeMaximum: 9700.99,
    amounts: [1516, 2217, 2570, 2871, 3158],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9701,
    combinedAdjustedNetIncomeMaximum: 9750.99,
    amounts: [1520, 2222, 2575, 2876, 3163],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9751,
    combinedAdjustedNetIncomeMaximum: 9800.99,
    amounts: [1527, 2232, 2586, 2889, 3178],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9801,
    combinedAdjustedNetIncomeMaximum: 9850.99,
    amounts: [1534, 2243, 2599, 2903, 3193],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9851,
    combinedAdjustedNetIncomeMaximum: 9900.99,
    amounts: [1541, 2254, 2611, 2917, 3209],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9901,
    combinedAdjustedNetIncomeMaximum: 9950.99,
    amounts: [1549, 2264, 2624, 2931, 3224],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 9951,
    combinedAdjustedNetIncomeMaximum: 10000.99,
    amounts: [1556, 2275, 2636, 2945, 3239],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10001,
    combinedAdjustedNetIncomeMaximum: 10050.99,
    amounts: [1563, 2285, 2649, 2959, 3254],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10051,
    combinedAdjustedNetIncomeMaximum: 10100.99,
    amounts: [1570, 2296, 2661, 2973, 3270],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10101,
    combinedAdjustedNetIncomeMaximum: 10150.99,
    amounts: [1577, 2306, 2674, 2986, 3285],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10151,
    combinedAdjustedNetIncomeMaximum: 10200.99,
    amounts: [1584, 2314, 2685, 2999, 3299],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10201,
    combinedAdjustedNetIncomeMaximum: 10250.99,
    amounts: [1591, 2318, 2689, 3004, 3304],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10251,
    combinedAdjustedNetIncomeMaximum: 10300.99,
    amounts: [1598, 2323, 2694, 3010, 3311],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10301,
    combinedAdjustedNetIncomeMaximum: 10350.99,
    amounts: [1606, 2329, 2702, 3018, 3319],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10351,
    combinedAdjustedNetIncomeMaximum: 10400.99,
    amounts: [1613, 2335, 2709, 3025, 3328],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10401,
    combinedAdjustedNetIncomeMaximum: 10450.99,
    amounts: [1620, 2342, 2716, 3033, 3337],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10451,
    combinedAdjustedNetIncomeMaximum: 10500.99,
    amounts: [1627, 2348, 2723, 3041, 3345],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10501,
    combinedAdjustedNetIncomeMaximum: 10550.99,
    amounts: [1634, 2355, 2730, 3049, 3354],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10551,
    combinedAdjustedNetIncomeMaximum: 10600.99,
    amounts: [1641, 2361, 2737, 3057, 3363],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10601,
    combinedAdjustedNetIncomeMaximum: 10650.99,
    amounts: [1648, 2367, 2744, 3065, 3371],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10651,
    combinedAdjustedNetIncomeMaximum: 10700.99,
    amounts: [1655, 2374, 2751, 3073, 3380],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10701,
    combinedAdjustedNetIncomeMaximum: 10750.99,
    amounts: [1663, 2380, 2758, 3081, 3389],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10751,
    combinedAdjustedNetIncomeMaximum: 10800.99,
    amounts: [1670, 2386, 2765, 3089, 3397],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10801,
    combinedAdjustedNetIncomeMaximum: 10850.99,
    amounts: [1677, 2393, 2772, 3097, 3406],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10851,
    combinedAdjustedNetIncomeMaximum: 10900.99,
    amounts: [1684, 2399, 2779, 3104, 3415],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10901,
    combinedAdjustedNetIncomeMaximum: 10950.99,
    amounts: [1691, 2405, 2786, 3112, 3424],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 10951,
    combinedAdjustedNetIncomeMaximum: 11000.99,
    amounts: [1698, 2412, 2793, 3120, 3432],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11001,
    combinedAdjustedNetIncomeMaximum: 11050.99,
    amounts: [1703, 2418, 2800, 3128, 3441],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11051,
    combinedAdjustedNetIncomeMaximum: 11100.99,
    amounts: [1708, 2424, 2807, 3136, 3450],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11101,
    combinedAdjustedNetIncomeMaximum: 11150.99,
    amounts: [1713, 2431, 2815, 3144, 3458],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11151,
    combinedAdjustedNetIncomeMaximum: 11200.99,
    amounts: [1718, 2437, 2822, 3152, 3467],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11201,
    combinedAdjustedNetIncomeMaximum: 11250.99,
    amounts: [1722, 2444, 2829, 3160, 3476],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11251,
    combinedAdjustedNetIncomeMaximum: 11300.99,
    amounts: [1727, 2450, 2836, 3168, 3484],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11301,
    combinedAdjustedNetIncomeMaximum: 11350.99,
    amounts: [1732, 2456, 2843, 3175, 3493],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11351,
    combinedAdjustedNetIncomeMaximum: 11400.99,
    amounts: [1736, 2463, 2850, 3183, 3502],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11401,
    combinedAdjustedNetIncomeMaximum: 11450.99,
    amounts: [1741, 2469, 2857, 3191, 3510],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11451,
    combinedAdjustedNetIncomeMaximum: 11500.99,
    amounts: [1746, 2475, 2864, 3199, 3519],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11501,
    combinedAdjustedNetIncomeMaximum: 11550.99,
    amounts: [1751, 2483, 2872, 3208, 3529],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11551,
    combinedAdjustedNetIncomeMaximum: 11600.99,
    amounts: [1756, 2490, 2881, 3218, 3540],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11601,
    combinedAdjustedNetIncomeMaximum: 11650.99,
    amounts: [1761, 2497, 2890, 3228, 3550],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11651,
    combinedAdjustedNetIncomeMaximum: 11700.99,
    amounts: [1766, 2505, 2898, 3237, 3561],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11701,
    combinedAdjustedNetIncomeMaximum: 11750.99,
    amounts: [1772, 2512, 2907, 3247, 3571],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11751,
    combinedAdjustedNetIncomeMaximum: 11800.99,
    amounts: [1777, 2520, 2915, 3256, 3582],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11801,
    combinedAdjustedNetIncomeMaximum: 11850.99,
    amounts: [1782, 2527, 2924, 3266, 3592],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11851,
    combinedAdjustedNetIncomeMaximum: 11900.99,
    amounts: [1787, 2534, 2932, 3275, 3603],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11901,
    combinedAdjustedNetIncomeMaximum: 11950.99,
    amounts: [1792, 2542, 2941, 3285, 3613],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 11951,
    combinedAdjustedNetIncomeMaximum: 12000.99,
    amounts: [1798, 2549, 2949, 3295, 3624],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12001,
    combinedAdjustedNetIncomeMaximum: 12050.99,
    amounts: [1803, 2557, 2958, 3304, 3635],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12051,
    combinedAdjustedNetIncomeMaximum: 12100.99,
    amounts: [1808, 2564, 2967, 3314, 3645],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12101,
    combinedAdjustedNetIncomeMaximum: 12150.99,
    amounts: [1813, 2571, 2975, 3323, 3656],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12151,
    combinedAdjustedNetIncomeMaximum: 12200.99,
    amounts: [1818, 2579, 2984, 3333, 3666],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12201,
    combinedAdjustedNetIncomeMaximum: 12250.99,
    amounts: [1824, 2586, 2992, 3342, 3677],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12251,
    combinedAdjustedNetIncomeMaximum: 12300.99,
    amounts: [1829, 2593, 3001, 3352, 3687],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12301,
    combinedAdjustedNetIncomeMaximum: 12350.99,
    amounts: [1834, 2601, 3009, 3362, 3698],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12351,
    combinedAdjustedNetIncomeMaximum: 12400.99,
    amounts: [1839, 2608, 3018, 3371, 3708],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12401,
    combinedAdjustedNetIncomeMaximum: 12450.99,
    amounts: [1844, 2616, 3027, 3381, 3719],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12451,
    combinedAdjustedNetIncomeMaximum: 12500.99,
    amounts: [1850, 2623, 3035, 3390, 3729],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12501,
    combinedAdjustedNetIncomeMaximum: 12550.99,
    amounts: [1855, 2630, 3044, 3400, 3740],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12551,
    combinedAdjustedNetIncomeMaximum: 12600.99,
    amounts: [1860, 2638, 3052, 3409, 3750],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12601,
    combinedAdjustedNetIncomeMaximum: 12650.99,
    amounts: [1865, 2645, 3061, 3419, 3761],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12651,
    combinedAdjustedNetIncomeMaximum: 12700.99,
    amounts: [1870, 2653, 3069, 3428, 3771],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12701,
    combinedAdjustedNetIncomeMaximum: 12750.99,
    amounts: [1876, 2660, 3078, 3438, 3782],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12751,
    combinedAdjustedNetIncomeMaximum: 12800.99,
    amounts: [1881, 2667, 3086, 3448, 3792],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12801,
    combinedAdjustedNetIncomeMaximum: 12850.99,
    amounts: [1886, 2675, 3095, 3457, 3803],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12851,
    combinedAdjustedNetIncomeMaximum: 12900.99,
    amounts: [1891, 2682, 3104, 3467, 3813],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12901,
    combinedAdjustedNetIncomeMaximum: 12950.99,
    amounts: [1896, 2690, 3112, 3476, 3824],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 12951,
    combinedAdjustedNetIncomeMaximum: 13000.99,
    amounts: [1902, 2697, 3121, 3486, 3834],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13001,
    combinedAdjustedNetIncomeMaximum: 13050.99,
    amounts: [1907, 2704, 3129, 3495, 3845],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13051,
    combinedAdjustedNetIncomeMaximum: 13100.99,
    amounts: [1912, 2712, 3138, 3505, 3855],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13101,
    combinedAdjustedNetIncomeMaximum: 13150.99,
    amounts: [1917, 2719, 3146, 3515, 3866],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13151,
    combinedAdjustedNetIncomeMaximum: 13200.99,
    amounts: [1922, 2727, 3155, 3524, 3877],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13201,
    combinedAdjustedNetIncomeMaximum: 13250.99,
    amounts: [1928, 2734, 3164, 3534, 3887],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13251,
    combinedAdjustedNetIncomeMaximum: 13300.99,
    amounts: [1933, 2741, 3172, 3543, 3898],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13301,
    combinedAdjustedNetIncomeMaximum: 13350.99,
    amounts: [1938, 2749, 3181, 3553, 3908],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13351,
    combinedAdjustedNetIncomeMaximum: 13400.99,
    amounts: [1943, 2756, 3189, 3562, 3919],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13401,
    combinedAdjustedNetIncomeMaximum: 13450.99,
    amounts: [1948, 2764, 3198, 3572, 3929],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13451,
    combinedAdjustedNetIncomeMaximum: 13500.99,
    amounts: [1953, 2769, 3204, 3579, 3937],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13501,
    combinedAdjustedNetIncomeMaximum: 13550.99,
    amounts: [1956, 2775, 3210, 3586, 3945],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13551,
    combinedAdjustedNetIncomeMaximum: 13600.99,
    amounts: [1960, 2780, 3216, 3593, 3952],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13601,
    combinedAdjustedNetIncomeMaximum: 13650.99,
    amounts: [1964, 2785, 3222, 3599, 3959],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13651,
    combinedAdjustedNetIncomeMaximum: 13700.99,
    amounts: [1968, 2791, 3228, 3606, 3967],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13701,
    combinedAdjustedNetIncomeMaximum: 13750.99,
    amounts: [1972, 2796, 3235, 3613, 3974],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13751,
    combinedAdjustedNetIncomeMaximum: 13800.99,
    amounts: [1976, 2802, 3241, 3620, 3982],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13801,
    combinedAdjustedNetIncomeMaximum: 13850.99,
    amounts: [1980, 2807, 3247, 3626, 3989],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13851,
    combinedAdjustedNetIncomeMaximum: 13900.99,
    amounts: [1984, 2812, 3253, 3633, 3997],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13901,
    combinedAdjustedNetIncomeMaximum: 13950.99,
    amounts: [1988, 2818, 3259, 3640, 4004],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 13951,
    combinedAdjustedNetIncomeMaximum: 14000.99,
    amounts: [1991, 2823, 3265, 3647, 4011],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14001,
    combinedAdjustedNetIncomeMaximum: 14050.99,
    amounts: [1995, 2828, 3271, 3653, 4019],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14051,
    combinedAdjustedNetIncomeMaximum: 14100.99,
    amounts: [1999, 2834, 3277, 3660, 4026],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14101,
    combinedAdjustedNetIncomeMaximum: 14150.99,
    amounts: [2003, 2839, 3283, 3667, 4034],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14151,
    combinedAdjustedNetIncomeMaximum: 14200.99,
    amounts: [2007, 2844, 3289, 3674, 4041],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14201,
    combinedAdjustedNetIncomeMaximum: 14250.99,
    amounts: [2011, 2850, 3295, 3681, 4049],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14251,
    combinedAdjustedNetIncomeMaximum: 14300.99,
    amounts: [2015, 2855, 3301, 3687, 4056],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14301,
    combinedAdjustedNetIncomeMaximum: 14350.99,
    amounts: [2019, 2861, 3307, 3694, 4063],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14351,
    combinedAdjustedNetIncomeMaximum: 14400.99,
    amounts: [2023, 2866, 3313, 3701, 4071],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14401,
    combinedAdjustedNetIncomeMaximum: 14450.99,
    amounts: [2026, 2871, 3319, 3708, 4078],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14451,
    combinedAdjustedNetIncomeMaximum: 14500.99,
    amounts: [2030, 2877, 3325, 3714, 4086],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14501,
    combinedAdjustedNetIncomeMaximum: 14550.99,
    amounts: [2034, 2882, 3331, 3721, 4093],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14551,
    combinedAdjustedNetIncomeMaximum: 14600.99,
    amounts: [2038, 2887, 3337, 3728, 4101],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14601,
    combinedAdjustedNetIncomeMaximum: 14650.99,
    amounts: [2042, 2893, 3343, 3735, 4108],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14651,
    combinedAdjustedNetIncomeMaximum: 14700.99,
    amounts: [2046, 2898, 3349, 3741, 4115],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14701,
    combinedAdjustedNetIncomeMaximum: 14750.99,
    amounts: [2050, 2904, 3355, 3748, 4123],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14751,
    combinedAdjustedNetIncomeMaximum: 14800.99,
    amounts: [2054, 2909, 3362, 3755, 4130],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14801,
    combinedAdjustedNetIncomeMaximum: 14850.99,
    amounts: [2058, 2914, 3368, 3762, 4138],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14851,
    combinedAdjustedNetIncomeMaximum: 14900.99,
    amounts: [2061, 2920, 3374, 3768, 4145],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14901,
    combinedAdjustedNetIncomeMaximum: 14950.99,
    amounts: [2065, 2925, 3380, 3775, 4153],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 14951,
    combinedAdjustedNetIncomeMaximum: 15000.99,
    amounts: [2069, 2930, 3386, 3782, 4160],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15001,
    combinedAdjustedNetIncomeMaximum: 15050.99,
    amounts: [2073, 2936, 3392, 3789, 4167],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15051,
    combinedAdjustedNetIncomeMaximum: 15100.99,
    amounts: [2077, 2941, 3398, 3795, 4175],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15101,
    combinedAdjustedNetIncomeMaximum: 15150.99,
    amounts: [2081, 2947, 3404, 3802, 4182],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15151,
    combinedAdjustedNetIncomeMaximum: 15200.99,
    amounts: [2085, 2952, 3410, 3809, 4190],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15201,
    combinedAdjustedNetIncomeMaximum: 15250.99,
    amounts: [2089, 2957, 3416, 3816, 4197],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15251,
    combinedAdjustedNetIncomeMaximum: 15300.99,
    amounts: [2093, 2963, 3422, 3822, 4205],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15301,
    combinedAdjustedNetIncomeMaximum: 15350.99,
    amounts: [2096, 2968, 3428, 3829, 4212],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15351,
    combinedAdjustedNetIncomeMaximum: 15400.99,
    amounts: [2100, 2973, 3434, 3836, 4219],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15401,
    combinedAdjustedNetIncomeMaximum: 15450.99,
    amounts: [2104, 2979, 3440, 3843, 4227],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15451,
    combinedAdjustedNetIncomeMaximum: 15500.99,
    amounts: [2108, 2984, 3446, 3849, 4234],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15501,
    combinedAdjustedNetIncomeMaximum: 15550.99,
    amounts: [2112, 2989, 3452, 3856, 4242],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15551,
    combinedAdjustedNetIncomeMaximum: 15600.99,
    amounts: [2116, 2995, 3458, 3863, 4249],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15601,
    combinedAdjustedNetIncomeMaximum: 15650.99,
    amounts: [2120, 3000, 3464, 3870, 4257],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15651,
    combinedAdjustedNetIncomeMaximum: 15700.99,
    amounts: [2124, 3006, 3470, 3876, 4264],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15701,
    combinedAdjustedNetIncomeMaximum: 15750.99,
    amounts: [2128, 3011, 3476, 3883, 4271],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15751,
    combinedAdjustedNetIncomeMaximum: 15800.99,
    amounts: [2131, 3016, 3482, 3890, 4279],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15801,
    combinedAdjustedNetIncomeMaximum: 15850.99,
    amounts: [2135, 3022, 3488, 3897, 4286],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15851,
    combinedAdjustedNetIncomeMaximum: 15900.99,
    amounts: [2139, 3027, 3495, 3903, 4294],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15901,
    combinedAdjustedNetIncomeMaximum: 15950.99,
    amounts: [2143, 3032, 3501, 3910, 4301],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 15951,
    combinedAdjustedNetIncomeMaximum: 16000.99,
    amounts: [2147, 3038, 3507, 3917, 4309],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16001,
    combinedAdjustedNetIncomeMaximum: 16050.99,
    amounts: [2151, 3043, 3513, 3924, 4316],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16051,
    combinedAdjustedNetIncomeMaximum: 16100.99,
    amounts: [2155, 3049, 3519, 3930, 4323],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16101,
    combinedAdjustedNetIncomeMaximum: 16150.99,
    amounts: [2159, 3054, 3525, 3937, 4331],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16151,
    combinedAdjustedNetIncomeMaximum: 16200.99,
    amounts: [2163, 3059, 3531, 3944, 4338],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16201,
    combinedAdjustedNetIncomeMaximum: 16250.99,
    amounts: [2166, 3065, 3537, 3951, 4346],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16251,
    combinedAdjustedNetIncomeMaximum: 16300.99,
    amounts: [2170, 3070, 3543, 3957, 4353],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16301,
    combinedAdjustedNetIncomeMaximum: 16350.99,
    amounts: [2174, 3075, 3549, 3964, 4361],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16351,
    combinedAdjustedNetIncomeMaximum: 16400.99,
    amounts: [2178, 3081, 3555, 3971, 4368],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16401,
    combinedAdjustedNetIncomeMaximum: 16450.99,
    amounts: [2182, 3086, 3561, 3978, 4375],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16451,
    combinedAdjustedNetIncomeMaximum: 16500.99,
    amounts: [2186, 3091, 3567, 3984, 4383],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16501,
    combinedAdjustedNetIncomeMaximum: 16550.99,
    amounts: [2190, 3097, 3573, 3991, 4390],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16551,
    combinedAdjustedNetIncomeMaximum: 16600.99,
    amounts: [2194, 3102, 3579, 3998, 4398],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16601,
    combinedAdjustedNetIncomeMaximum: 16650.99,
    amounts: [2198, 3108, 3585, 4005, 4405],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16651,
    combinedAdjustedNetIncomeMaximum: 16700.99,
    amounts: [2201, 3113, 3591, 4011, 4413],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16701,
    combinedAdjustedNetIncomeMaximum: 16750.99,
    amounts: [2205, 3118, 3597, 4018, 4420],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16751,
    combinedAdjustedNetIncomeMaximum: 16800.99,
    amounts: [2209, 3124, 3603, 4025, 4427],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16801,
    combinedAdjustedNetIncomeMaximum: 16850.99,
    amounts: [2213, 3129, 3609, 4032, 4435],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16851,
    combinedAdjustedNetIncomeMaximum: 16900.99,
    amounts: [2217, 3134, 3615, 4038, 4442],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16901,
    combinedAdjustedNetIncomeMaximum: 16950.99,
    amounts: [2221, 3140, 3622, 4045, 4450],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 16951,
    combinedAdjustedNetIncomeMaximum: 17000.99,
    amounts: [2225, 3145, 3628, 4052, 4457],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17001,
    combinedAdjustedNetIncomeMaximum: 17050.99,
    amounts: [2229, 3151, 3634, 4059, 4465],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17051,
    combinedAdjustedNetIncomeMaximum: 17100.99,
    amounts: [2233, 3156, 3640, 4065, 4472],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17101,
    combinedAdjustedNetIncomeMaximum: 17150.99,
    amounts: [2236, 3161, 3646, 4072, 4479],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17151,
    combinedAdjustedNetIncomeMaximum: 17200.99,
    amounts: [2240, 3167, 3652, 4079, 4487],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17201,
    combinedAdjustedNetIncomeMaximum: 17250.99,
    amounts: [2244, 3172, 3658, 4086, 4494],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17251,
    combinedAdjustedNetIncomeMaximum: 17300.99,
    amounts: [2248, 3177, 3664, 4093, 4502],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17301,
    combinedAdjustedNetIncomeMaximum: 17350.99,
    amounts: [2252, 3183, 3670, 4099, 4509],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17351,
    combinedAdjustedNetIncomeMaximum: 17400.99,
    amounts: [2256, 3188, 3676, 4106, 4517],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17401,
    combinedAdjustedNetIncomeMaximum: 17450.99,
    amounts: [2260, 3194, 3682, 4113, 4524],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17451,
    combinedAdjustedNetIncomeMaximum: 17500.99,
    amounts: [2264, 3199, 3688, 4120, 4531],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17501,
    combinedAdjustedNetIncomeMaximum: 17550.99,
    amounts: [2268, 3204, 3694, 4126, 4539],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17551,
    combinedAdjustedNetIncomeMaximum: 17600.99,
    amounts: [2271, 3210, 3700, 4133, 4546],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17601,
    combinedAdjustedNetIncomeMaximum: 17650.99,
    amounts: [2275, 3215, 3706, 4140, 4554],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17651,
    combinedAdjustedNetIncomeMaximum: 17700.99,
    amounts: [2279, 3220, 3712, 4147, 4561],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17701,
    combinedAdjustedNetIncomeMaximum: 17750.99,
    amounts: [2283, 3226, 3718, 4153, 4569],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17751,
    combinedAdjustedNetIncomeMaximum: 17800.99,
    amounts: [2287, 3231, 3724, 4160, 4576],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17801,
    combinedAdjustedNetIncomeMaximum: 17850.99,
    amounts: [2291, 3236, 3730, 4167, 4583],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17851,
    combinedAdjustedNetIncomeMaximum: 17900.99,
    amounts: [2295, 3242, 3736, 4174, 4591],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17901,
    combinedAdjustedNetIncomeMaximum: 17950.99,
    amounts: [2299, 3247, 3742, 4180, 4598],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 17951,
    combinedAdjustedNetIncomeMaximum: 18000.99,
    amounts: [2303, 3253, 3748, 4187, 4606],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18001,
    combinedAdjustedNetIncomeMaximum: 18050.99,
    amounts: [2306, 3258, 3755, 4194, 4613],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18051,
    combinedAdjustedNetIncomeMaximum: 18100.99,
    amounts: [2310, 3263, 3761, 4201, 4621],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18101,
    combinedAdjustedNetIncomeMaximum: 18150.99,
    amounts: [2314, 3269, 3767, 4207, 4628],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18151,
    combinedAdjustedNetIncomeMaximum: 18200.99,
    amounts: [2318, 3274, 3773, 4214, 4635],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18201,
    combinedAdjustedNetIncomeMaximum: 18250.99,
    amounts: [2322, 3279, 3779, 4221, 4643],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18251,
    combinedAdjustedNetIncomeMaximum: 18300.99,
    amounts: [2326, 3285, 3785, 4228, 4650],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18301,
    combinedAdjustedNetIncomeMaximum: 18350.99,
    amounts: [2330, 3290, 3791, 4234, 4658],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18351,
    combinedAdjustedNetIncomeMaximum: 18400.99,
    amounts: [2334, 3296, 3797, 4241, 4665],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18401,
    combinedAdjustedNetIncomeMaximum: 18450.99,
    amounts: [2338, 3301, 3803, 4248, 4673],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18451,
    combinedAdjustedNetIncomeMaximum: 18500.99,
    amounts: [2341, 3306, 3809, 4255, 4680],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18501,
    combinedAdjustedNetIncomeMaximum: 18550.99,
    amounts: [2345, 3312, 3815, 4261, 4687],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18551,
    combinedAdjustedNetIncomeMaximum: 18600.99,
    amounts: [2349, 3317, 3821, 4268, 4695],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18601,
    combinedAdjustedNetIncomeMaximum: 18650.99,
    amounts: [2353, 3322, 3827, 4275, 4702],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18651,
    combinedAdjustedNetIncomeMaximum: 18700.99,
    amounts: [2357, 3328, 3833, 4282, 4710],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18701,
    combinedAdjustedNetIncomeMaximum: 18750.99,
    amounts: [2361, 3333, 3839, 4288, 4717],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18751,
    combinedAdjustedNetIncomeMaximum: 18800.99,
    amounts: [2365, 3339, 3845, 4295, 4725],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18801,
    combinedAdjustedNetIncomeMaximum: 18850.99,
    amounts: [2369, 3344, 3851, 4302, 4732],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18851,
    combinedAdjustedNetIncomeMaximum: 18900.99,
    amounts: [2373, 3349, 3857, 4309, 4740],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18901,
    combinedAdjustedNetIncomeMaximum: 18950.99,
    amounts: [2376, 3355, 3863, 4315, 4747],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 18951,
    combinedAdjustedNetIncomeMaximum: 19000.99,
    amounts: [2380, 3360, 3869, 4322, 4754],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19001,
    combinedAdjustedNetIncomeMaximum: 19050.99,
    amounts: [2384, 3365, 3875, 4329, 4762],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19051,
    combinedAdjustedNetIncomeMaximum: 19100.99,
    amounts: [2388, 3371, 3882, 4336, 4769],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19101,
    combinedAdjustedNetIncomeMaximum: 19150.99,
    amounts: [2392, 3376, 3888, 4342, 4777],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19151,
    combinedAdjustedNetIncomeMaximum: 19200.99,
    amounts: [2396, 3381, 3894, 4349, 4784],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19201,
    combinedAdjustedNetIncomeMaximum: 19250.99,
    amounts: [2400, 3387, 3900, 4356, 4792],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19251,
    combinedAdjustedNetIncomeMaximum: 19300.99,
    amounts: [2404, 3392, 3906, 4363, 4799],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19301,
    combinedAdjustedNetIncomeMaximum: 19350.99,
    amounts: [2408, 3398, 3912, 4369, 4806],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19351,
    combinedAdjustedNetIncomeMaximum: 19400.99,
    amounts: [2411, 3403, 3918, 4376, 4814],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19401,
    combinedAdjustedNetIncomeMaximum: 19450.99,
    amounts: [2415, 3408, 3924, 4383, 4821],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19451,
    combinedAdjustedNetIncomeMaximum: 19500.99,
    amounts: [2419, 3414, 3930, 4390, 4829],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19501,
    combinedAdjustedNetIncomeMaximum: 19550.99,
    amounts: [2423, 3419, 3936, 4396, 4836],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19551,
    combinedAdjustedNetIncomeMaximum: 19600.99,
    amounts: [2427, 3424, 3942, 4403, 4844],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19601,
    combinedAdjustedNetIncomeMaximum: 19650.99,
    amounts: [2431, 3430, 3948, 4410, 4851],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19651,
    combinedAdjustedNetIncomeMaximum: 19700.99,
    amounts: [2435, 3435, 3954, 4417, 4858],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19701,
    combinedAdjustedNetIncomeMaximum: 19750.99,
    amounts: [2439, 3441, 3960, 4423, 4866],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19751,
    combinedAdjustedNetIncomeMaximum: 19800.99,
    amounts: [2443, 3446, 3966, 4430, 4873],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19801,
    combinedAdjustedNetIncomeMaximum: 19850.99,
    amounts: [2446, 3451, 3972, 4437, 4881],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19851,
    combinedAdjustedNetIncomeMaximum: 19900.99,
    amounts: [2450, 3457, 3978, 4444, 4888],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19901,
    combinedAdjustedNetIncomeMaximum: 19950.99,
    amounts: [2454, 3462, 3984, 4450, 4896],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 19951,
    combinedAdjustedNetIncomeMaximum: 20000.99,
    amounts: [2458, 3467, 3990, 4457, 4903],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20001,
    combinedAdjustedNetIncomeMaximum: 20050.99,
    amounts: [2462, 3473, 3996, 4464, 4910],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20051,
    combinedAdjustedNetIncomeMaximum: 20100.99,
    amounts: [2466, 3478, 4002, 4471, 4918],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20101,
    combinedAdjustedNetIncomeMaximum: 20150.99,
    amounts: [2470, 3483, 4009, 4477, 4925],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20151,
    combinedAdjustedNetIncomeMaximum: 20200.99,
    amounts: [2474, 3489, 4015, 4484, 4933],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20201,
    combinedAdjustedNetIncomeMaximum: 20250.99,
    amounts: [2478, 3494, 4021, 4491, 4940],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20251,
    combinedAdjustedNetIncomeMaximum: 20300.99,
    amounts: [2481, 3500, 4027, 4498, 4948],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20301,
    combinedAdjustedNetIncomeMaximum: 20350.99,
    amounts: [2485, 3505, 4033, 4505, 4955],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20351,
    combinedAdjustedNetIncomeMaximum: 20400.99,
    amounts: [2489, 3510, 4039, 4511, 4962],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20401,
    combinedAdjustedNetIncomeMaximum: 20450.99,
    amounts: [2493, 3516, 4045, 4518, 4970],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20451,
    combinedAdjustedNetIncomeMaximum: 20500.99,
    amounts: [2497, 3521, 4051, 4525, 4977],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20501,
    combinedAdjustedNetIncomeMaximum: 20550.99,
    amounts: [2501, 3526, 4057, 4532, 4985],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20551,
    combinedAdjustedNetIncomeMaximum: 20600.99,
    amounts: [2505, 3532, 4063, 4538, 4992],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20601,
    combinedAdjustedNetIncomeMaximum: 20650.99,
    amounts: [2509, 3537, 4069, 4545, 5000],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20651,
    combinedAdjustedNetIncomeMaximum: 20700.99,
    amounts: [2513, 3543, 4075, 4552, 5007],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20701,
    combinedAdjustedNetIncomeMaximum: 20750.99,
    amounts: [2516, 3548, 4081, 4559, 5014],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20751,
    combinedAdjustedNetIncomeMaximum: 20800.99,
    amounts: [2520, 3553, 4087, 4565, 5022],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20801,
    combinedAdjustedNetIncomeMaximum: 20850.99,
    amounts: [2524, 3559, 4093, 4572, 5029],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20851,
    combinedAdjustedNetIncomeMaximum: 20900.99,
    amounts: [2528, 3564, 4099, 4579, 5037],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20901,
    combinedAdjustedNetIncomeMaximum: 20950.99,
    amounts: [2532, 3569, 4105, 4586, 5044],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 20951,
    combinedAdjustedNetIncomeMaximum: 21000.99,
    amounts: [2536, 3575, 4111, 4592, 5052],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21001,
    combinedAdjustedNetIncomeMaximum: 21050.99,
    amounts: [2540, 3580, 4117, 4599, 5059],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21051,
    combinedAdjustedNetIncomeMaximum: 21100.99,
    amounts: [2544, 3586, 4123, 4606, 5066],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21101,
    combinedAdjustedNetIncomeMaximum: 21150.99,
    amounts: [2548, 3591, 4129, 4613, 5074],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21151,
    combinedAdjustedNetIncomeMaximum: 21200.99,
    amounts: [2551, 3596, 4135, 4619, 5081],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21201,
    combinedAdjustedNetIncomeMaximum: 21250.99,
    amounts: [2555, 3602, 4142, 4626, 5089],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21251,
    combinedAdjustedNetIncomeMaximum: 21300.99,
    amounts: [2559, 3607, 4148, 4633, 5096],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21301,
    combinedAdjustedNetIncomeMaximum: 21350.99,
    amounts: [2563, 3612, 4154, 4640, 5104],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21351,
    combinedAdjustedNetIncomeMaximum: 21400.99,
    amounts: [2567, 3618, 4160, 4646, 5111],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21401,
    combinedAdjustedNetIncomeMaximum: 21450.99,
    amounts: [2571, 3623, 4166, 4653, 5118],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21451,
    combinedAdjustedNetIncomeMaximum: 21500.99,
    amounts: [2575, 3628, 4172, 4660, 5126],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21501,
    combinedAdjustedNetIncomeMaximum: 21550.99,
    amounts: [2579, 3634, 4178, 4667, 5133],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21551,
    combinedAdjustedNetIncomeMaximum: 21600.99,
    amounts: [2583, 3639, 4184, 4673, 5141],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21601,
    combinedAdjustedNetIncomeMaximum: 21650.99,
    amounts: [2586, 3645, 4190, 4680, 5148],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21651,
    combinedAdjustedNetIncomeMaximum: 21700.99,
    amounts: [2590, 3650, 4196, 4687, 5156],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21701,
    combinedAdjustedNetIncomeMaximum: 21750.99,
    amounts: [2594, 3655, 4202, 4694, 5163],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21751,
    combinedAdjustedNetIncomeMaximum: 21800.99,
    amounts: [2598, 3661, 4208, 4700, 5170],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21801,
    combinedAdjustedNetIncomeMaximum: 21850.99,
    amounts: [2602, 3666, 4214, 4707, 5178],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21851,
    combinedAdjustedNetIncomeMaximum: 21900.99,
    amounts: [2606, 3671, 4219, 4712, 5183],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21901,
    combinedAdjustedNetIncomeMaximum: 21950.99,
    amounts: [2610, 3676, 4224, 4717, 5188],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 21951,
    combinedAdjustedNetIncomeMaximum: 22000.99,
    amounts: [2614, 3681, 4228, 4722, 5193],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22001,
    combinedAdjustedNetIncomeMaximum: 22050.99,
    amounts: [2617, 3685, 4233, 4726, 5197],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22051,
    combinedAdjustedNetIncomeMaximum: 22100.99,
    amounts: [2621, 3690, 4238, 4731, 5202],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22101,
    combinedAdjustedNetIncomeMaximum: 22150.99,
    amounts: [2625, 3695, 4242, 4736, 5207],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22151,
    combinedAdjustedNetIncomeMaximum: 22200.99,
    amounts: [2629, 3700, 4247, 4741, 5212],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22201,
    combinedAdjustedNetIncomeMaximum: 22250.99,
    amounts: [2633, 3705, 4252, 4745, 5216],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22251,
    combinedAdjustedNetIncomeMaximum: 22300.99,
    amounts: [2637, 3709, 4257, 4750, 5221],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22301,
    combinedAdjustedNetIncomeMaximum: 22350.99,
    amounts: [2641, 3714, 4261, 4755, 5226],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22351,
    combinedAdjustedNetIncomeMaximum: 22400.99,
    amounts: [2644, 3719, 4266, 4759, 5231],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22401,
    combinedAdjustedNetIncomeMaximum: 22450.99,
    amounts: [2648, 3724, 4271, 4764, 5235],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22451,
    combinedAdjustedNetIncomeMaximum: 22500.99,
    amounts: [2652, 3729, 4275, 4769, 5240],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22501,
    combinedAdjustedNetIncomeMaximum: 22550.99,
    amounts: [2656, 3733, 4280, 4774, 5245],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22551,
    combinedAdjustedNetIncomeMaximum: 22600.99,
    amounts: [2660, 3738, 4285, 4778, 5250],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22601,
    combinedAdjustedNetIncomeMaximum: 22650.99,
    amounts: [2664, 3743, 4289, 4783, 5254],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22651,
    combinedAdjustedNetIncomeMaximum: 22700.99,
    amounts: [2668, 3748, 4294, 4788, 5259],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22701,
    combinedAdjustedNetIncomeMaximum: 22750.99,
    amounts: [2671, 3753, 4299, 4792, 5264],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22751,
    combinedAdjustedNetIncomeMaximum: 22800.99,
    amounts: [2675, 3757, 4303, 4797, 5269],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22801,
    combinedAdjustedNetIncomeMaximum: 22850.99,
    amounts: [2679, 3762, 4308, 4802, 5273],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22851,
    combinedAdjustedNetIncomeMaximum: 22900.99,
    amounts: [2683, 3767, 4313, 4807, 5278],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22901,
    combinedAdjustedNetIncomeMaximum: 22950.99,
    amounts: [2687, 3772, 4317, 4811, 5283],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 22951,
    combinedAdjustedNetIncomeMaximum: 23000.99,
    amounts: [2691, 3777, 4322, 4816, 5288],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23001,
    combinedAdjustedNetIncomeMaximum: 23050.99,
    amounts: [2695, 3781, 4327, 4821, 5292],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23051,
    combinedAdjustedNetIncomeMaximum: 23100.99,
    amounts: [2698, 3786, 4332, 4825, 5297],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23101,
    combinedAdjustedNetIncomeMaximum: 23150.99,
    amounts: [2702, 3791, 4336, 4830, 5302],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23151,
    combinedAdjustedNetIncomeMaximum: 23200.99,
    amounts: [2706, 3796, 4341, 4835, 5307],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23201,
    combinedAdjustedNetIncomeMaximum: 23250.99,
    amounts: [2710, 3801, 4346, 4840, 5311],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23251,
    combinedAdjustedNetIncomeMaximum: 23300.99,
    amounts: [2714, 3805, 4350, 4844, 5316],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23301,
    combinedAdjustedNetIncomeMaximum: 23350.99,
    amounts: [2718, 3810, 4355, 4849, 5321],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23351,
    combinedAdjustedNetIncomeMaximum: 23400.99,
    amounts: [2722, 3815, 4360, 4854, 5326],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23401,
    combinedAdjustedNetIncomeMaximum: 23450.99,
    amounts: [2725, 3820, 4364, 4859, 5330],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23451,
    combinedAdjustedNetIncomeMaximum: 23500.99,
    amounts: [2729, 3825, 4369, 4863, 5335],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23501,
    combinedAdjustedNetIncomeMaximum: 23550.99,
    amounts: [2733, 3829, 4374, 4868, 5340],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23551,
    combinedAdjustedNetIncomeMaximum: 23600.99,
    amounts: [2737, 3834, 4378, 4873, 5345],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23601,
    combinedAdjustedNetIncomeMaximum: 23650.99,
    amounts: [2741, 3839, 4383, 4877, 5349],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23651,
    combinedAdjustedNetIncomeMaximum: 23700.99,
    amounts: [2745, 3844, 4388, 4882, 5354],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23701,
    combinedAdjustedNetIncomeMaximum: 23750.99,
    amounts: [2749, 3849, 4392, 4887, 5359],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23751,
    combinedAdjustedNetIncomeMaximum: 23800.99,
    amounts: [2752, 3853, 4397, 4892, 5364],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23801,
    combinedAdjustedNetIncomeMaximum: 23850.99,
    amounts: [2756, 3858, 4402, 4896, 5369],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23851,
    combinedAdjustedNetIncomeMaximum: 23900.99,
    amounts: [2760, 3863, 4407, 4901, 5373],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23901,
    combinedAdjustedNetIncomeMaximum: 23950.99,
    amounts: [2764, 3868, 4411, 4906, 5378],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 23951,
    combinedAdjustedNetIncomeMaximum: 24000.99,
    amounts: [2768, 3873, 4416, 4910, 5383],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24001,
    combinedAdjustedNetIncomeMaximum: 24050.99,
    amounts: [2772, 3877, 4421, 4915, 5388],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24051,
    combinedAdjustedNetIncomeMaximum: 24100.99,
    amounts: [2776, 3882, 4425, 4920, 5392],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24101,
    combinedAdjustedNetIncomeMaximum: 24150.99,
    amounts: [2779, 3887, 4430, 4925, 5397],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24151,
    combinedAdjustedNetIncomeMaximum: 24200.99,
    amounts: [2783, 3892, 4435, 4929, 5402],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24201,
    combinedAdjustedNetIncomeMaximum: 24250.99,
    amounts: [2787, 3897, 4439, 4934, 5407],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24251,
    combinedAdjustedNetIncomeMaximum: 24300.99,
    amounts: [2791, 3901, 4444, 4939, 5411],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24301,
    combinedAdjustedNetIncomeMaximum: 24350.99,
    amounts: [2795, 3906, 4449, 4943, 5416],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24351,
    combinedAdjustedNetIncomeMaximum: 24400.99,
    amounts: [2799, 3911, 4453, 4948, 5421],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24401,
    combinedAdjustedNetIncomeMaximum: 24450.99,
    amounts: [2803, 3916, 4458, 4953, 5426],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24451,
    combinedAdjustedNetIncomeMaximum: 24500.99,
    amounts: [2806, 3921, 4463, 4958, 5430],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24501,
    combinedAdjustedNetIncomeMaximum: 24550.99,
    amounts: [2810, 3925, 4467, 4962, 5435],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24551,
    combinedAdjustedNetIncomeMaximum: 24600.99,
    amounts: [2814, 3930, 4472, 4967, 5440],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24601,
    combinedAdjustedNetIncomeMaximum: 24650.99,
    amounts: [2818, 3935, 4477, 4972, 5445],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24651,
    combinedAdjustedNetIncomeMaximum: 24700.99,
    amounts: [2822, 3940, 4482, 4976, 5449],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24701,
    combinedAdjustedNetIncomeMaximum: 24750.99,
    amounts: [2826, 3945, 4486, 4981, 5454],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24751,
    combinedAdjustedNetIncomeMaximum: 24800.99,
    amounts: [2830, 3949, 4491, 4986, 5459],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24801,
    combinedAdjustedNetIncomeMaximum: 24850.99,
    amounts: [2833, 3954, 4496, 4991, 5464],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24851,
    combinedAdjustedNetIncomeMaximum: 24900.99,
    amounts: [2837, 3959, 4500, 4995, 5468],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24901,
    combinedAdjustedNetIncomeMaximum: 24950.99,
    amounts: [2841, 3964, 4505, 5000, 5473],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  },
  {
    combinedAdjustedNetIncomeMinimum: 24951,
    combinedAdjustedNetIncomeMaximum: 25000.00,
    amounts: [2845, 3969, 4510, 5005, 5478],
    lowIncomes: [false, false, false, false, false],
    incomeArea: 'c' as const
  }
];
